/*
 *  Round real loss tolerance to the nearest 5% from -10% to -40%
 */
function roundLossTolerance(value) {
  if (value < -0.4) value = -0.4;
  if (value > -0.05) value = -0.05;
  return Math.round(value / 0.05) * 0.05;
}

/*
 *  Round real RROR to the nearest 1% from 5% to 20%
 */
function roundRROR(value) {
  if (value < 0.05) value = 0.05;
  if (value > 0.2) value = 0.2;
  return Math.round(value / 0.01) * 0.01;
}

function isFloat(num) {
  return Number(num) === num && num % 1 !== 0;
}

function roundTwoDecimal(num) {
  const negativeModifier = num < 0 ? -1 : 1;
  return (Math.round((Math.abs(num) + Number.EPSILON) * 100) / 100) * negativeModifier;
}

export const CyMath = {
  roundLossTolerance,
  roundRROR,
  isFloat,
  roundTwoDecimal,
};




// WEBPACK FOOTER //
// ./src/utilities/math.js